import Api from './api'
import axios from 'axios'

/* Cancel several routes */
const CancelToken = axios.CancelToken
let cancelToken

export default {
  getTilesBuildingFloor (icao, building, floor) {
    return Api.get(`/airports/tiles/${icao}`)
      .then(response => response.data)
      .catch(err => {
        throw new Error(err)
      })
  },
  getAirport (icao, language) {
    return Api.get(`/airports/${icao}?building_bounds=true&lang=${language}`)
      .then(response => response.data)
      .catch(err => {
        throw new Error(err)
      })
  },
  getPoisCatalog (language) {
    return Api.get(`/pois/catalog?lang=${language}`)
      .then(response => response.data)
      .catch(err => {
        throw new Error(err)
      })
  },
  getPoisList (icao, language) {
    return Api.get(`/pois/${icao}/list?lang=${language}`, {
      version: 'v3'
    })
      .then(response => response.data)
      .catch(err => {
        throw new Error(err)
      })
  },
  getUncategorizedPoisList (icao, language) {
    return Api.get(`/elements/${icao}/points?lang=${language}`, {
      version: 'v3'
    })
      .then(response => response.data)
      .catch(err => {
        throw new Error(err)
      })
  },
  getRoute (icao, data) {
    if (cancelToken) {
      cancelToken()
    }
    return Api.post(`/routes/${icao}`, data, {
      cancelToken: new CancelToken(function executor (c) {
        // An executor function receives a cancel function as a parameter
        cancelToken = c
      })
    })
      .then(response => response.data)
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw new Error(err)
        } else {
          throw new Error('Request canceled manually')
        }
      })
  },
  async getAccessControlTime (code) {
    const response = await Api.get(`/airports/${code}/accesscontrols`)
    return response.data
  }
}
